const production = true

export const BASE_URL = production
	? 'https://connect-platform-api.loyal.id/api/v1/'
	: 'https://retail-dev.loyal.id/api/v1/'

export const CLIENT_CODE = '110101'
